import { takeEvery, put } from 'redux-saga/effects';
import { 
  GET_USERS,
  ADD_USER,
  EDIT_USER,
  DELETE_USER,
  EXPORT_USER,
} from '../action';

import { 
  getListUser,
  addNewUser,
  editAUser,
  deleteAUser,
  exportDataUser
} from '../../service';

import ToastTopHelper from '../../../../utils/toast';

function* getUsers({params}) {
  const { success, data } = yield getListUser(params);
 
  if (success) {
    yield put({
      type: GET_USERS.SUCCESS,
      data: data,
    });
  } else {
    yield put({
      type: GET_USERS.FAIL,
      data: data,
    });
  }
}

function* editUser({params}) {
  const { success, data } = yield editAUser(params);
 
  if (success) {
    yield put({
      type: EDIT_USER.SUCCESS,
      data: data,
    });
    ToastTopHelper.success("Bạn đã cập nhật nhân viên thành công.");
  } else {
    if(data.error) {
      ToastTopHelper.error(data.error);
    } 
    yield put({
      type: EDIT_USER.FAIL,
      data: data,
    });
  }
}

function* addUser({params}) {
  const { success, data } = yield addNewUser(params);
  if (success) {
    yield put({
      type: ADD_USER.SUCCESS,
      data: data,
    });
    ToastTopHelper.success("Bạn đã thêm nhân viên thành công.");
  } else {
    if(data.error) {
      ToastTopHelper.error(data.error);
    } 
    yield put({
      type: ADD_USER.FAIL,
      data: data,
    });
  }
}

function* deleteUser({params}) {
  const { success, data } = yield deleteAUser(params);
 
  if (success) {
    yield put({
      type: DELETE_USER.SUCCESS,
      data: data,
    });
    ToastTopHelper.success("Bạn đã xóa nhân viên thành công.")
  } else {
    if(data.error) {
      ToastTopHelper.error(data.error);
    } 
    yield put({
      type: DELETE_USER.FAIL,
      data: data,
    });
  }
}

function* exportData({params}) {
  const { success, data } = yield exportDataUser(params);
 
  if (success) {
    yield put({
      type: EXPORT_USER.SUCCESS,
      data: data,
    });
  } else {
    yield put({
      type: EXPORT_USER.FAIL,
      data: data,
    });
  }
}

export default function* () {
  yield takeEvery(GET_USERS.REQUEST, getUsers);
  yield takeEvery(ADD_USER.REQUEST, addUser);
  yield takeEvery(EDIT_USER.REQUEST, editUser);
  yield takeEvery(DELETE_USER.REQUEST, deleteUser);
  yield takeEvery(EXPORT_USER.REQUEST, exportData);
}
